import { Selector, State, StateContext, createSelector } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { QuotationsResult, QuoteEntry } from '../@models';
import { Injectable, Injector } from '@angular/core';
import { Pagination } from '../@config';
import { QuotationsService } from '../@services';
import { QuotationSearchFilter } from '../@models/quotation/quotation-filter.model';
@State<QuotationsResult>({
  name: 'quotations',
  defaults: {
    totalCount: 0,
    items: [],
    skipCount: 0,
    loading: false,
  }
})
@Injectable()
export class QuotationsState {

  private static service: QuotationsService;

  @Selector()
  static totalItems(state: QuotationsResult): number {
    return state.totalCount || 0;
  }
  @Selector()
  static loadedItems(state: QuotationsResult): number {
    return state.items?.length;
  }

  @Selector()
  static isLoading(state: QuotationsResult) {
    return state.loading;
  }

  @Selector()
  static getAll(state: QuotationsResult): QuoteEntry[] {
    return state.items;
  }

  static hasAny() {
    return createSelector([QuotationsState], (state: QuotationsResult) => {
      return state.items?.length > 0;
    });
  }

  static getById(id: number) {
    return createSelector([QuotationsState], (state: QuotationsResult) => {
      return state.items.find((quotation: QuoteEntry) => quotation.id === id);
    });
  }

  constructor(injector: Injector) {
    QuotationsState.service = injector.get(QuotationsService);
  }

  @Receiver()
  static loadFirst({ setState, getState }: StateContext<QuotationsState>, searchFilter: QuotationSearchFilter) {
    setState({ ...getState(), loading: true });
    this.service.getQuotations(0, searchFilter).subscribe(
      (result: QuotationsResult) => {
        const newState = { ...result, skipCount: 0, loading: false };
        setState(newState);
      },
      (error) => {
        // Ensure loading is set to false even on error
        setState({ ...getState(), loading: false });
      }
    );
  }

  @Receiver()
  static loadNext({ setState, getState }: StateContext<QuotationsResult>, searchFilter: QuotationSearchFilter) {
    const state: QuotationsResult = getState();
    let skipCount: number = state.skipCount + Pagination.skipCount;
    if (skipCount > state.totalCount) {
      skipCount = state.totalCount;
    }
    this.service.getQuotations(skipCount, searchFilter).subscribe(
      {
        next: (result: QuotationsResult) => {
          const tasks = [...state.items, ...result.items];
          const newState = { ...result, items: tasks, skipCount };
          setState(newState);
        }
      })
  }
}
